import BaseBridge from 'config/bridge/BaseBridge'
import BaseService from 'config/bridge/BaseService'
import { BridgeMockUserInfo } from 'config/bridge/BridgeMock'
import useBoundState from 'store'
import { IRedemptionResponse, IRepurchaseRequest } from 'store/redemption/types'

export default class RedemptionService {
  static async redeemValue() {
    let headers = {}
    const { utmCampaign } = useBoundState.getState()

    if (BaseBridge.isBrowser()) {
      headers = {
        'x-inter-user-bank-account': BridgeMockUserInfo.account,
        utm_campaign: utmCampaign,
        repurchaseQuantity: 0,
      }
    } else {
      headers = {
        utm_campaign: utmCampaign,
      }
    }
    const response = await BaseService.doExecute<IRedemptionResponse>({
      method: 'POST',
      endpoint: `${process.env.REACT_APP_API_CAPITALIZATION}/redemption`,
      headers,
    })

    return response.data
  }

  static async repurchase({ repurchaseQuantity }: IRepurchaseRequest) {
    let headers = {}
    const data = { repurchaseQuantity }
    const { utmCampaign } = useBoundState.getState()

    if (BaseBridge.isBrowser()) {
      headers = {
        'x-inter-user-bank-account': BridgeMockUserInfo.account,
        utm_campaign: utmCampaign,
      }
    } else {
      headers = {
        utm_campaign: utmCampaign,
      }
    }

    const response = await BaseService.doExecute<IRedemptionResponse>({
      method: 'POST',
      endpoint: `${process.env.REACT_APP_API_CAPITALIZATION}/redemption`,
      headers,
      data,
    })

    return response.data
  }
}
